import React from "react";
import Container from "@mui/material/Container";
import NewsAndArticlesContainer from "containers/NewsAndArticles";
import PageTitle from "components/PageTitle";
import Box from "components/common/Box";
import { tracker } from "library/tracker";
import { MOBILE_GUTTER } from "components/allInOneDashboard/constants/mobileTheme";

/** Cancel LayoutWeb content gutters so page padding matches Explore. */
const LAYOUT_GUTTER_CANCEL = { xs: -2, md: -3 };

const NewsAndArticles = () => {
    React.useEffect(() => {
        tracker.pageView();
    }, []);

    return (
        <Box sx={{ width: "100%", mx: LAYOUT_GUTTER_CANCEL }}>
            <Container
                maxWidth="xl"
                sx={{
                    px: { xs: MOBILE_GUTTER, md: 4, lg: 7.5 },
                    pb: { xs: 2, md: 3 },
                }}
            >
                <PageTitle
                    heading="News & Articles"
                    showBackToDashboard={true}
                    disableBreadcrumb={true}
                    sx={{ pb: 0 }}
                />
                <NewsAndArticlesContainer />
            </Container>
        </Box>
    );
};

export default NewsAndArticles;
